import { render, staticRenderFns } from "./InstagramConfiguration.vue?vue&type=template&id=c2357ba2"
import script from "./InstagramConfiguration.vue?vue&type=script&lang=js"
export * from "./InstagramConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports